export var GatewayStatus;
(function (GatewayStatus) {
    GatewayStatus[GatewayStatus["UNKNOWN"] = 0] = "UNKNOWN";
    GatewayStatus[GatewayStatus["CHECKING"] = 1] = "CHECKING";
    GatewayStatus[GatewayStatus["NOT_REQUESTED"] = 2] = "NOT_REQUESTED";
    GatewayStatus[GatewayStatus["COLLECTING_USER_INFORMATION"] = 3] = "COLLECTING_USER_INFORMATION";
    GatewayStatus[GatewayStatus["PROOF_OF_WALLET_OWNERSHIP"] = 4] = "PROOF_OF_WALLET_OWNERSHIP";
    GatewayStatus[GatewayStatus["IN_REVIEW"] = 5] = "IN_REVIEW";
    GatewayStatus[GatewayStatus["REJECTED"] = 6] = "REJECTED";
    GatewayStatus[GatewayStatus["REVOKED"] = 7] = "REVOKED";
    GatewayStatus[GatewayStatus["FROZEN"] = 8] = "FROZEN";
    GatewayStatus[GatewayStatus["ACTIVE"] = 9] = "ACTIVE";
    GatewayStatus[GatewayStatus["ERROR"] = 10] = "ERROR";
    GatewayStatus[GatewayStatus["LOCATION_NOT_SUPPORTED"] = 11] = "LOCATION_NOT_SUPPORTED";
    GatewayStatus[GatewayStatus["VPN_NOT_SUPPORTED"] = 12] = "VPN_NOT_SUPPORTED";
    GatewayStatus[GatewayStatus["REFRESH_TOKEN_REQUIRED"] = 13] = "REFRESH_TOKEN_REQUIRED";
    GatewayStatus[GatewayStatus["VALIDATING_USER_INFORMATION"] = 14] = "VALIDATING_USER_INFORMATION";
    GatewayStatus[GatewayStatus["USER_INFORMATION_VALIDATED"] = 15] = "USER_INFORMATION_VALIDATED";
    GatewayStatus[GatewayStatus["USER_INFORMATION_REJECTED"] = 16] = "USER_INFORMATION_REJECTED";
})(GatewayStatus || (GatewayStatus = {}));
